import { Router } from '@vaadin/router'
import { html } from 'lit'
import { customElement, state } from 'lit/decorators.js'
import { inject, Symbols } from '../../di'
import { HighlightListStore } from '../../stores'
import { View } from '../view'

@customElement('kob-highlight-list')
export class HighlightsView extends View {

    @inject(Symbols.stores.highlightList)
    highlightList: HighlightListStore

    @state()
    private activeChapter = 0

    handleSearchChanged = (e) => {
        // this.highlightList.setSearch(e.target.value)
    }

    showChapter = (index: number) => () => {
        this.activeChapter = index
        const { chapterSlug } = this.highlightList.chapterStores[index]
        document.getElementById(chapterSlug)?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        })
    }

    returnToBooks = (e?: Event) => {
        e?.preventDefault()
        Router.go('/')
    }

    render() {
        return html`
            <kob-busy .stores=${[this.highlightList]}></kob-busy>
            ${this.renderResults()}
            ${this.renderNone()}
        `
    }

    renderResults() {
        if (!this.highlightList.hasEntities) return
        const chapters = this.highlightList.chapterStores
        return html`
            <section class="hl-head">
                <div class="hl-head-inner">
                    <a class="back-link" href="/" @click=${this.returnToBooks}>
                        <vaadin-icon icon="vaadin:arrow-left"></vaadin-icon>
                        Books
                    </a>
                    <div class="hl-head-divider"></div>
                    <div>
                        <div class="hl-head-title">Highlights</div>
                        <div class="hl-count">
                            <strong>${this.highlightList.stores.length}</strong> highlights ·
                            <strong>${chapters.length}</strong> chapters
                        </div>
                    </div>
                    <div class="hl-head-spacer"></div>
                    <vaadin-text-field
                        placeholder="Search highlights in this book"
                        clear-button-visible
                        @change=${this.handleSearchChanged}
                    ></vaadin-text-field>
                </div>
            </section>

            <main class="reader" aria-label="Highlights">
                <aside class="toc" aria-label="Chapters">
                    <div class="toc-card">
                        <div class="toc-title">Chapters</div>
                        <div class="toc-list">
                            ${chapters.map((chapterHighlights, index) => html`
                                <div
                                    class="toc-item depth-${Math.min(chapterHighlights.chapterDepth, 2)} ${index === this.activeChapter ? 'active' : ''}"
                                    @click=${this.showChapter(index)}
                                >
                                    <span class="t">${chapterHighlights.chapter}</span>
                                    <span class="n">${chapterHighlights.stores.length}</span>
                                </div>
                            `)}
                        </div>
                    </div>
                </aside>

                <div class="chapters">
                    ${chapters.map(chapterHighlights => html`
                        <section class="chapter" id=${chapterHighlights.chapterSlug}>
                            <div class="chapter-head">
                                <h3>${chapterHighlights.chapter}</h3>
                                <span class="c-count">${chapterHighlights.stores.length} highlights</span>
                            </div>
                            ${chapterHighlights.stores.map(store => html`
                                <div class="hl">
                                    <p>${store.text}</p>
                                </div>
                            `)}
                        </section>
                    `)}
                </div>
            </main>
        `
    }

    renderNone() {
        if (this.highlightList.hasEntities || this.highlightList.busy) return ''
        return html`
            <div class="empty-wrap">
                <div class="empty">
                    <vaadin-icon icon="vaadin:pencil"></vaadin-icon>
                    <h4>No highlights yet</h4>
                    <p>Highlights you make on your Kobo show up here after the next sync.</p>
                    <vaadin-button theme="tertiary" @click=${this.returnToBooks}>Return to books</vaadin-button>
                </div>
            </div>
        `
    }

    async connectedCallback() {
        await super.connectedCallback()
        const params = new URLSearchParams(window.location.search)
        const bookID = params.get('bookID')
        if (bookID)
            this.highlightList.setBookId(bookID)
        else
            Router.go('/')
    }
}
